import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import TimeInputForm from './TimeInputComponent';
import TimeIcon from '../../icons/time.svg';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

const TimeInput = ({
  label,
  onChange,
  value
}) => {
  const ref = useRef(null);
  const [date, setDate] = useState(value);
  const [startTime, setStartTime] = useState(value.format('hh:mm'));

  const handleSetStartTime = (time) => {
    const tempTime = time.split(':');
    const tempDate = date;
    tempDate.hours(tempTime[0] === '12' ? '00' : tempTime[0]).minutes(tempTime[1]);
    setDate(tempDate);
    setStartTime(tempDate.format('hh:mm'));
    onChange(tempDate);
  };

  const updateTime = () => {
    const val = date.format('A');
    if (val === 'PM') {
      date.subtract(12, 'h');
    }
    if (val === 'AM') {
      date.add(12, 'h');
    }
    onChange(date);
  };

  const amPmValue = date.format('a');

  return (
    <>
      <div className={styles.timeInput} ref={ref}>
        <div className={styles.container}>
          <TimeIcon />
          <span className={styles.label}>{label}</span>
          <TimeInputForm
            initTime={startTime}
            className={styles.input}
            onTimeChange={handleSetStartTime}
          />
        </div>
        <div className={styles.element} onClick={() => updateTime()}>
          <span className={styles.value}>
            <span className={cx({ current: amPmValue === 'am' })}>am</span> / <span className={cx({ current: amPmValue === 'pm' })}>pm</span>
          </span>
        </div>
      </div>
    </>
  );
};

TimeInput.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func,
  label: PropTypes.string,
};

export default TimeInput;
